import { AxiosError } from 'axios';

import { ErrorWithDetails, ErrorWithNodeData } from '@app-velocity/common';

import { ErrorMessage } from '@app-velocity/ui';

import { ErrorWithNavigate } from '../../../../../../../components/ErrorWithNavigate';

export type ConfigureScenarioErrorProps = {
  error:
    | string
    | AxiosError
    | Error
    | ErrorWithDetails
    | ErrorWithNodeData
    | null;
};

export const ConfigureScenarioError = ({
  error,
}: ConfigureScenarioErrorProps) => {
  if (error instanceof ErrorWithNodeData)
    return <ErrorWithNavigate error={error} />;

  return <ErrorMessage error={error} />;
};
